import { createContext, useContext, useMemo } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { LOCALES, DEFAULT_LANG, isLang, pathFor, resolvePage } from "./index";
import { TREATMENTS, CATEGORIES } from "../data/treatments";

const LocaleCtx = createContext(null);

export function LocaleProvider({ children }) {
  const params = useParams();
  const navigate = useNavigate();
  const rawLang = params.lang;
  const lang = isLang(rawLang) ? rawLang : DEFAULT_LANG;
  const rest = params["*"] || "";
  const [seg1, seg2] = rest.split("/").filter(Boolean);
  const resolved = resolvePage(lang, seg1, seg2, TREATMENTS, CATEGORIES);

  const value = useMemo(() => {
    const dict = LOCALES[lang] || LOCALES[DEFAULT_LANG];
    const fallback = LOCALES[DEFAULT_LANG];
    const t = (path) => {
      const pick = (obj) => path.split(".").reduce((o, k) => (o && o[k] !== undefined ? o[k] : undefined), obj);
      const v = pick(dict);
      return v !== undefined ? v : pick(fallback);
    };
    const link = (pageKey, treatmentSlug) => pathFor(lang, pageKey, treatmentSlug);
    const switchLang = (target) => {
      localStorage.setItem("imperium-lang", target);
      let subSlug;
      if (resolved.pageKey === "treatment" && resolved.treatment) subSlug = resolved.treatment.slugs[target];
      else if (resolved.pageKey === "category" && resolved.category) subSlug = resolved.category.slugs[target];
      const baseKey = resolved.pageKey === "treatment" || resolved.pageKey === "category" ? "treatments" : resolved.pageKey === "notfound" ? "home" : resolved.pageKey;
      navigate(pathFor(target, baseKey, subSlug));
    };
    return { lang, t, link, switchLang, pageKey: resolved.pageKey, treatment: resolved.treatment || null, category: resolved.category || null, langValid: isLang(rawLang) };
  }, [lang, resolved.pageKey, resolved.treatment, resolved.category, navigate]);

  return <LocaleCtx.Provider value={value}>{children}</LocaleCtx.Provider>;
}

export function useLocale() {
  return useContext(LocaleCtx);
}
